import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  useColorModeValue,
  useToast,
  Spinner,
  Flex,
  TableContainer,
  Link,
} from "@chakra-ui/react";
import { ExternalLinkIcon } from "@chakra-ui/icons";
import { getInventoryProjects } from "../../InventoryServices/InventoryProjectTabsAPI/ProjectTabAPI";

const ProjectTab = ({ parentInventoryId, refreshTrigger }) => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  const { id } = useParams();

  const headerBg = useColorModeValue("blue.500", "blue.600");
  const headerColor = useColorModeValue("white", "gray.100");
  const rowHoverBg = useColorModeValue("blue.50", "gray.700");
  const textColor = useColorModeValue("gray.800", "gray.100");
  const subTextColor = useColorModeValue("gray.500", "gray.400");
  const linkColor = useColorModeValue("blue.600", "blue.300");

  useEffect(() => {
    fetchProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentInventoryId, refreshTrigger]);

  const fetchProjects = async () => {
    try {
      setLoading(true);
      // ✅ Service function use kar rahe hain
      const response = await getInventoryProjects(id);

      if (response.data?.status && Array.isArray(response.data.data)) {
        setProjects(response.data.data);
      } else {
        setProjects([]);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
      setProjects([]);
      toast({
        title: "Error",
        description: "Failed to load projects",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Flex justify="center" align="center" minH="200px">
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
          size="lg"
        />
      </Flex>
    );
  }

  return (
    <Box border="1px solid" borderColor="gray.200" shadow="sm" borderRadius="md" overflow="hidden">
      <TableContainer>
        <Table variant="simple" size="md">
          <Thead bg={headerBg}>
            <Tr>
              <Th color={headerColor} fontSize="sm">
                S.No.
              </Th>
              <Th color={headerColor} fontSize="sm">
                Project ID
              </Th>
              <Th color={headerColor} fontSize="sm">
                Project Link
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {projects.length > 0 ? (
              projects.map((project, index) => (
                <Tr
                  key={project.project_id || index}
                  _hover={{
                    bg: rowHoverBg,
                    transform: "scale(1.01)",
                    transition: "all 0.2s",
                  }}
                >
                  <Td>
                    <Text fontSize="sm" fontFamily="mono" color={textColor}>
                      {index + 1}
                    </Text>
                  </Td>
                  <Td>
                    <Text fontWeight="600" fontSize="sm" fontFamily="mono" color={textColor}>
                      {project.project_id || "-"}
                    </Text>
                  </Td>
                  <Td>
                    <Link
                      href={project.project_link}
                      isExternal
                      color={linkColor}
                      fontWeight="500"
                      display="flex"
                      alignItems="center"
                      gap={1}
                      _hover={{ textDecoration: "underline" }}
                    >
                      Open Project
                      <ExternalLinkIcon mx="2px" />
                    </Link>
                  </Td>
                </Tr>
              ))
            ) : (
              <Tr>
                <Td colSpan={3} textAlign="center" py={8}>
                  <Text color={subTextColor} fontStyle="italic">
                    No data found
                  </Text>
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ProjectTab;
